// import { weui } from "weui.js";
// var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
// function weuiAlert() {
//     var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
//     var yes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
//     var options = arguments[2];

//     if ((typeof yes === 'undefined' ? 'undefined' : _typeof(yes)) === 'object') {
//         options = yes;
//         yes = undefined;
//     }


//     return weui.alert(content, yes, {
//         buttons: [{
//             label: this.$t("ok"),
//         }]
//     });
// }
console.log("process.env.NODE_ENV=", process.env.NODE_ENV)
if (process.env.NODE_ENV === 'development') {
    window.debugLog = console.log.bind(console);
} else {
    window.debugLog = function () { };
}

export function isValidString(str) {
    // // 定义一个正则表达式，匹配中文、字母、数字和下划线
    // var regex = /^[\u4E00-\u9FA5a-zA-Z0-9_\-\.]+$/;

    // // 使用test方法检查字符串是否符合模式
    // return regex.test(str);
    // 定义一个正则表达式，匹配斜杆和反斜杠
    var regex = /[/\\]/;

    // 使用test方法检测字符串是否不包含斜杆和反斜杠
    return !regex.test(str);
}
export function compareVersions(version1, version2) {
    const parts1 = version1.split('.').map(Number);
    const parts2 = version2.split('.').map(Number);

    for (let i = 0; i < Math.max(parts1.length, parts2.length); i++) {
        const part1 = parts1[i] || 0;
        const part2 = parts2[i] || 0;

        if (part1 < part2) {
            return -1;
        } else if (part1 > part2) {
            return 1;
        }
    }
    return 0;
}

